export { default } from './DownloadBrochure';



// WEBPACK FOOTER //
// ./src/components/templates/DownloadBrochure/index.js